import { templateDir, mediaQuery } from '../../global.var';

// Get logo element
const logo = <HTMLImageElement>document.querySelector('.header__logo');

// Change icon if query matches
function changeIcon() {
  if (mediaQuery.mobileLarge.matches) {
    logo.src = `${templateDir}/assets/img/logo_white.svg`;
  } else {
    logo.src = `${templateDir}/assets/img/logo.svg`;
  }
}

// Call function for page init
changeIcon();

// Add change event to query
mediaQuery.mobileLarge.addEventListener('change', changeIcon);
